//////////////////////////////////////////////////////////////////////////////////////   IMPORT
///////////////////////////////////////////////////////////   REACT
import React, { Component } from 'react';
///////////////////////////////////////////////////////////   LIBS
import PropTypes from 'prop-types';
import videojs from 'video.js';
import { isEqual } from 'lodash';
import 'videojs-hotkeys';
import PeakMeter from './video-player-peakmeter';
///////////////////////////////////////////////////////////   SETTINGS
import { _SETTINGS } from 'config/settings';
import { huLang } from './videojs-hun-language';
///////////////////////////////////////////////////////////   CSS
import 'video.js/dist/video-js.css';
//////////////////////////////////////////////////////////////////////////////////////    CLASS SETUP


class VideoPlayer extends Component<any, { [key: string]: any }> {



  static propTypes = {
    src: PropTypes.string,
    poster: PropTypes.string,
    controls: PropTypes.bool,
    autoplay: PropTypes.bool,
    preload: PropTypes.oneOf(['auto', 'none', 'metadata']),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    hideControls: PropTypes.arrayOf(PropTypes.string),
    bigPlayButton: PropTypes.bool,
    bigPlayButtonCentered: PropTypes.bool,
    onReady: PropTypes.func,
    onPlay: PropTypes.func,
    onPause: PropTypes.func,
    onTimeUpdate: PropTypes.func,
    onSeeking: PropTypes.func,
    onSeeked: PropTypes.func,
    onEnd: PropTypes.func,
    playbackRates: PropTypes.arrayOf(PropTypes.number),
    hidePlaybackRates: PropTypes.bool,
    className: PropTypes.string,
    fluid: PropTypes.bool,
    responsive: PropTypes.bool
  };
  static defaultProps = {
    src: '',
    poster: '',
    controls: true,
    autoplay: true,
    preload: 'auto',
    playbackRates: [0.5, 1, 1.5, 2, 2.35, 3, 3.65],
    hidePlaybackRates: false,
    className: '',
    hideControls: [],
    bigPlayButton: true,
    bigPlayButtonCentered: true,
    fluid: false,
    responsive: false,
    onReady: () => { },
    onPlay: () => { },
    onPause: () => { },
    onTimeUpdate: () => { },
    onSeeking: () => { },
    onSeeked: () => { },
    onEnd: () => { }
  };
  dater: any = new Date();
  playerId: string = `the-video`;
  peakerObject: {} | any = {};
  player: {} | any = {};
  Controls = {
    play: 'playToggle',
    volume: 'VolumeMenuButton',
    seekbar: 'progressControl',
    timer: 'timeDisplay',
    playbackrates: 'playbackRateMenuButton',
    fullscreen: 'fullscreenToggle'
  };




  ///////////////////////////////////////////////////////////   LIFECYCLE METHODS
  componentDidMount() {
    this.initPlayer(this.props);
    this.playerEvents(this.props);
  }
  componentDidUpdate(nextProps: any, prevProps: any) {
    if (isEqual(this.props, nextProps)) {
      this.initPlayer(nextProps);
    }
  }
  componentWillUnmount() {
    if (this.player) this.player.dispose();
  }
  ///////////////////////////////////////////////////////////   CLASS METHODS
  /**
   * Init Player
   * @param props
   */
  private initPlayer(props: any): void {
    videojs.addLanguage('hu', huLang);
    const playerOptions = this.setPlayerOptions(props);
    const domE: any = document.querySelector(`#${this.playerId}`);
    this.player = videojs(domE, playerOptions);
    this.player.src(props.src);
    this.player.poster(props.poster);
  }
  /**
   * Set Player Options
   * @param props
   */
  private setPlayerOptions(props: any): any {
    const playerOptions: any = {};
    playerOptions.controls = props.controls;
    playerOptions.autoplay = props.autoplay;
    playerOptions.preload = props.preload;
    playerOptions.width = props.width;
    playerOptions.height = props.height;
    playerOptions.bigPlayButton = props.bigPlayButton;
    playerOptions.fluid = false;
    playerOptions.responsive = true;
    const hidePlaybackRates = props.hidePlaybackRates || props.hideControls.includes('playbackrates');
    if (!hidePlaybackRates) playerOptions.playbackRates = props.playbackRates;
    return playerOptions;
  }



  private PeakMeter(props: any): void {

  }

  /**
   * PLayer events
   * @param props
   */
  private playerEvents = (props: any) => {
    this.player.ready(() => {
      props.onReady(this.player);
      videojs(this.player.id_).ready(() => {
        this.player.hotkeys({
          volumeStep: 0.1,
          seekStep: 1 / _SETTINGS.basic.frameRate,
          enableMute: true,
          enableVolumeScroll: true,
          enableFullscreen: true,
          enableModifiersForNumbers: false,
          enableNumbers: true,
          enableJogStyle: true
        });
      });
    });

    this.player.on('play', () => {
      props.onPlay(this.player.currentTime());
      //console.log("elindult");
    });
    this.player.on('pause', () => {
      props.onPause(this.player.currentTime());
      //console.log("megállt");
    });
    this.player.on('timeupdate', (e: any) => {
      props.onTimeUpdate();
    });
    this.player.on('seeking', () => {
      this.player.off('timeupdate', () => { });
      this.player.one('seeked', () => { });
      props.onSeeking();
    });
    this.player.on('seeked', () => {
      props.onSeeked();
    });
    this.player.on('ended', () => {
      props.onEnd();
    });
    this.player.on('volumechange', () => {
      localStorage.setItem('volumer', parseFloat(this.player.volume()).toFixed(1));
    });
  };
  ///////////////////////////////////////////////////////////   RENDER
  render() {
    return (
      <video id={this.playerId} className={`video-js ${this.props.bigPlayButtonCentered ? 'vjs-big-play-centered' : ''} ${this.props.className}`}></video>


    )



  }
}

export default VideoPlayer;
